module.exports = __webpack_public_path__ + "img/two.8f474fdd.png";